export default "__VITE_ASSET__bFsJ53ER__"